/* Wamory 2099 layer, whole site (styles in wamory-2099-site.css).
   Everywhere: neon scroll progress, scroll-in reveals below the first screen, 3D product cards and a spotlight on desktop,
   a heart burst on add to cart, a back-to-top orb. Product pages: sticky buy bar, hover zoom, share button, HUD ticker,
   recently viewed (kept in this browser only). Content never depends on this script. */
(() => {
  const ar = document.documentElement.lang !== 'en';
  const t = (a, e) => (ar ? a : e);
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const root = (window.WAMORY_ROUTES?.root_url || '/').replace(/\/$/, '');
  const store = { get(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} } };
  const el = (tag, cls, html, hidden) => { const n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; if (hidden) n.setAttribute('aria-hidden', 'true'); return n; };
  const esc = s => String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let toastTimer = 0;
  const toast = msg => { let n = document.querySelector('.w99-toast'); if (!n) { n = el('div', 'w99-toast'); n.setAttribute('role', 'status'); document.body.append(n); } n.textContent = msg; n.classList.add('w99-show'); clearTimeout(toastTimer); toastTimer = setTimeout(() => n.classList.remove('w99-show'), 2200); };

  if (!calm) document.body.append(el('div', 'w99-progress', null, true));

  // Reveal sections and cards as they scroll in; only things that start below the first screen, so nothing above it flickers.
  if (!calm && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('w99-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    const watch = scope => scope.querySelectorAll('.product-card, .wm-home-shortcuts, .wm-home-deals, .wm-home-row, .wm-stage-banner, .wm-all-banner, .journal-section, .wm-benefits, .wm-editorial, .wm-details, .wm-reviews, .wm-related, .wm-bottom-trust, .w99-recent').forEach(n => {
      if (n.classList.contains('w99-reveal') || n.getBoundingClientRect().top < window.innerHeight) return;
      if (n.classList.contains('product-card') && n.parentElement) n.style.setProperty('--w99-i', String([...n.parentElement.children].indexOf(n) % 6));
      n.classList.add('w99-reveal'); io.observe(n);
    });
    watch(document);
    new MutationObserver(list => list.forEach(m => m.addedNodes.forEach(n => { if (n.nodeType === 1 && (n.matches('.product-card') || n.querySelector('.product-card'))) watch(n.parentElement || document); }))).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('beforeprint', () => document.querySelectorAll('.w99-reveal').forEach(n => n.classList.add('w99-in')));
  }

  // A short tap feel on phones that support it (Android) when adding to the bag.
  document.addEventListener('click', e => {
    const b = e.target.closest('.wm-add, .add-button, .w99-buybar button, [data-wm-added-step]');
    if (b && !b.disabled && navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} }
  });

  // Heart burst from any add-to-cart button.
  if (!calm) document.addEventListener('click', e => {
    const b = e.target.closest('.wm-add, .add-button, .w99-buybar button');
    if (!b || b.disabled) return;
    const r = b.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    ['💗', '✨', '🤍', '💖', '✦', '💗', '🤍', '✨'].forEach((s, i) => {
      const h = el('span', 'w99-heart', s), a = (Math.PI * 2 * i) / 8 - Math.PI / 2, d = 60 + Math.random() * 40;
      h.style.cssText = `left:${cx}px;top:${cy}px;--x:${Math.cos(a) * d}px;--y:${Math.sin(a) * d - 30}px;--r:${(Math.random() - 0.5) * 80}deg`;
      document.body.append(h); setTimeout(() => h.remove(), 1000);
    });
  });

  if (fine && !calm) {
    // Tilt product cards toward the pointer.
    let tilted = null;
    document.addEventListener('pointermove', e => {
      const card = e.target.closest('.product-card');
      if (tilted && tilted !== card) { tilted.classList.remove('w99-tilt'); tilted.style.removeProperty('--w99-rx'); tilted.style.removeProperty('--w99-ry'); tilted = null; }
      if (!card) return;
      const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.classList.add('w99-tilt'); card.style.setProperty('--w99-ry', (x * 8).toFixed(2) + 'deg'); card.style.setProperty('--w99-rx', (-y * 8).toFixed(2) + 'deg'); tilted = card;
    }, { passive: true });
    // Spotlight.
    const glow = el('div', 'w99-glow', null, true); document.body.append(glow);
    let gx = 0, gy = 0, frame = 0;
    document.addEventListener('pointermove', e => { gx = e.clientX; gy = e.clientY; glow.classList.add('w99-glow-on'); if (!frame) frame = requestAnimationFrame(() => { glow.style.transform = `translate3d(${gx}px,${gy}px,0)`; frame = 0; }); }, { passive: true });
    document.documentElement.addEventListener('pointerleave', () => glow.classList.remove('w99-glow-on'));
  }

  // Back-to-top orb (desktop; hidden by CSS on small screens).
  const top = el('button', 'w99-top', '<span aria-hidden="true">↑</span>');
  top.type = 'button'; top.setAttribute('aria-label', t('العودة إلى الأعلى', 'Back to top'));
  top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' }));
  document.body.append(top);
  let ticking = false;
  window.addEventListener('scroll', () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { top.classList.toggle('w99-show', window.scrollY > window.innerHeight * 1.5); ticking = false; }); }, { passive: true });

  // First-order offer wording. FIRST50 is AED 50 off a first order of AED 150 or more, but the FAQ and rewards text
  // drawn by help-data.js / policy-content.js still says "50% off, capped at AED 50". Those modules are pinned by the
  // CDN (same-name bare imports), so the sentences are corrected here after they are drawn.
  const offerFixes = [
    ['استخدمي FIRST50 للحصول على خصم 50% على أول طلب مؤهل، بحد أقصى 50 درهمًا إماراتيًا أو ما يعادله بعملة الدفع.', 'استخدمي FIRST50 للحصول على خصم 50 درهمًا إماراتيًا (أو ما يعادلها بعملة الدفع) على أول طلب مؤهل من 150 درهمًا أو أكثر.'],
    ['استمتعي بخصم <bdi dir="ltr">50%</bdi> على أول طلب مؤهل باستخدام FIRST50، بحد أقصى 50 د.إ.', 'استمتعي بخصم 50 د.إ على أول طلب مؤهل من 150 د.إ أو أكثر باستخدام FIRST50.'],
    ['خصم <bdi dir="ltr">50%</bdi> على أول طلب مؤهل باستخدام الكود FIRST50، بحد أقصى 50 درهمًا إماراتيًا أو ما يعادله بعملة الدفع.', 'خصم 50 درهمًا إماراتيًا (أو ما يعادلها بعملة الدفع) على أول طلب مؤهل من 150 درهمًا أو أكثر باستخدام الكود FIRST50.'],
    ['Use FIRST50 for 50% off your first eligible order, capped at AED 50 or the equivalent in your checkout currency.', 'Use FIRST50 for AED 50 off (or the equivalent in your checkout currency) your first eligible order of AED 150 or more.'],
    ['Enjoy <bdi dir="ltr">50%</bdi> off your first eligible order with FIRST50, capped at AED 50.', 'Enjoy AED 50 off your first eligible order of AED 150 or more with FIRST50.'],
    ['Get <bdi dir="ltr">50%</bdi> off your first eligible order with code FIRST50, capped at AED 50 or the equivalent in your checkout currency.', 'Get AED 50 off (or the equivalent in your checkout currency) your first eligible order of AED 150 or more with code FIRST50.']
  ];
  const fixOffers = () => document.querySelectorAll('p, li, dd').forEach(n => {
    if (!n.innerHTML.includes('FIRST50') || !n.textContent.includes('50%')) return;
    let html = n.innerHTML;
    offerFixes.forEach(([from, to]) => { html = html.split(from).join(to); });
    if (html !== n.innerHTML) n.innerHTML = html;
  });
  if (document.querySelector('#faq-root, #policy-root, #guide-root, #search-root, #contact-root, #notfound-root')) {
    fixOffers();
    let pending = 0;
    new MutationObserver(() => { if (!pending) pending = requestAnimationFrame(() => { pending = 0; fixOffers(); }); }).observe(document.body, { childList: true, subtree: true });
  }

  // ---------- Product pages ----------
  const landing = document.querySelector('.wm-landing');
  if (!landing) return;
  const title = landing.querySelector('h1')?.textContent.trim() || document.title;
  const mainImg = landing.querySelector('.wm-main-image');
  const priceEl = landing.querySelector('.wm-price'), compareEl = landing.querySelector('.wm-compare');
  const addBtn = landing.querySelector('.wm-add');
  const thumb = () => (mainImg?.currentSrc || mainImg?.src || '').replace(/width=\d+/, 'width=240');

  // Hover zoom follows the pointer.
  const stage = landing.querySelector('.wm-stage');
  if (stage && mainImg && fine && !calm) {
    stage.classList.add('w99-zoom');
    stage.addEventListener('pointermove', e => { const r = stage.getBoundingClientRect(); mainImg.style.setProperty('--w99-zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%'); mainImg.style.setProperty('--w99-zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'); }, { passive: true });
  }

  // Tap the main photo for a full-screen view (pinch to zoom on phones); tap, swipe down or Esc to close.
  if (mainImg) {
    mainImg.style.cursor = 'zoom-in';
    mainImg.setAttribute('role', 'button'); mainImg.setAttribute('tabindex', '0');
    mainImg.setAttribute('aria-label', t('عرض الصورة بالحجم الكامل', 'View photo full screen'));
    const open = () => {
      const src = (mainImg.currentSrc || mainImg.src || '').replace(/([?&])width=\d+/, '$1width=1800');
      const box = el('div', 'w99-viewer', `<button type="button" class="w99-viewer-x" aria-label="${t('إغلاق', 'Close')}">×</button><img alt="${esc(mainImg.alt || title)}" src="${esc(src)}">`);
      box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
      let startY = null;
      const close = () => { box.classList.remove('w99-viewer-in'); setTimeout(() => box.remove(), 220); document.removeEventListener('keydown', onKey); mainImg.focus(); };
      const onKey = e => { if (e.key === 'Escape') close(); };
      box.addEventListener('click', e => { if (e.target === box || e.target.closest('.w99-viewer-x')) close(); });
      box.addEventListener('touchstart', e => { if (e.touches.length === 1) startY = e.touches[0].clientY; }, { passive: true });
      box.addEventListener('touchend', e => { if (startY !== null && e.changedTouches[0].clientY - startY > 90) close(); startY = null; });
      document.addEventListener('keydown', onKey);
      document.body.append(box); requestAnimationFrame(() => box.classList.add('w99-viewer-in'));
      box.querySelector('.w99-viewer-x').focus();
    };
    // One tap opens the viewer; a double tap saves to favourites with a big heart (see "Double tap" below).
    let taps = 0, tapTimer = 0;
    mainImg.addEventListener('click', e => {
      if (mainImg.dataset.w99Swiped) { delete mainImg.dataset.w99Swiped; return; }
      if (++taps === 1) { tapTimer = setTimeout(() => { taps = 0; open(); }, 260); return; }
      clearTimeout(tapTimer); taps = 0; likePhoto(e);
    });
    mainImg.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  }

  // Share button under the title.
  const h1 = landing.querySelector('h1');
  if (h1) {
    const share = el('button', 'w99-share', `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg>${t('مشاركة', 'Share')}`);
    share.type = 'button';
    share.addEventListener('click', async () => {
      const url = location.origin + location.pathname;
      if (navigator.share) { try { await navigator.share({ title, url }); } catch (e) {} return; }
      try { await navigator.clipboard.writeText(url); toast(t('تم نسخ رابط المنتج ✨', 'Product link copied ✨')); } catch (e) { toast(url); }
    });
    (landing.querySelector('.wm-subtitle') || h1).after(share);
  }

  // HUD ticker under the buy row.
  const buyRow = landing.querySelector('.wm-buy-row');
  if (buyRow) {
    const mw = root + '/pages/my-wamory';
    const items = ar
      ? `<span>رصيد 7% في ماي واموري على الطلبات المؤهلة</span><a href="${mw}">تجربة ماي واموري: مساحتكِ الشخصية لكِ ولصغيركِ</a><span>احفظي مفضلاتكِ وتابعي رحلة طفلكِ</span><span>دفع آمن</span><span>منتجات مختارة بعناية</span><a class="w99-cta" href="${mw}">سجّلي الآن ↖</a>`
      : `<span>7% My Wamory credit on eligible orders</span><a href="${mw}">The My Wamory experience: your personal space</a><span>Save favourites and follow your baby's journey</span><span>Secure payment</span><span>Carefully chosen products</span><a class="w99-cta" href="${mw}">Sign up now ↗</a>`;
    const copy = items.replace(/<span>/g, '<span aria-hidden="true">').replace(/<a /g, '<a tabindex="-1" aria-hidden="true" ');
    const ticker = el('div', 'w99-ticker', `<div class="w99-ticker-track">${items}${copy}</div>`);
    buyRow.after(ticker);
  }

  // Sticky buy bar once the main add button scrolls away.
  if (addBtn && 'IntersectionObserver' in window) {
    const bar = el('div', 'w99-buybar');
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `<img alt="" width="44" height="44"><span class="w99-buybar-copy"><strong></strong><span class="w99-buybar-price"></span></span><button type="button" tabindex="-1">${t('أضيفي إلى السلة', 'Add to bag')}</button>`;
    const sync = () => {
      bar.querySelector('img').src = thumb();
      bar.querySelector('strong').textContent = title;
      const sale = compareEl && !compareEl.hidden && compareEl.textContent.trim();
      const p = bar.querySelector('.w99-buybar-price');
      p.className = 'w99-buybar-price' + (sale ? ' w99-sale' : '');
      p.innerHTML = `<span dir="ltr">${esc(priceEl?.textContent.trim())}</span>` + (sale ? ` <s dir="ltr">${esc(compareEl.textContent.trim())}</s>` : '');
      bar.querySelector('button').disabled = addBtn.disabled;
    };
    sync();
    bar.querySelector('button').addEventListener('click', () => addBtn.click());
    document.body.append(bar);
    [priceEl, compareEl, addBtn, mainImg].forEach(n => n && new MutationObserver(sync).observe(n, { attributes: true, childList: true, characterData: true, subtree: true }));
    new IntersectionObserver(([e]) => { const below = e.boundingClientRect.top < 0; bar.classList.toggle('w99-show', !e.isIntersecting && below); }, { threshold: 0 }).observe(addBtn);
  }

  // Double tap the photo: a big heart blooms on it and the product is saved to favourites (never un-saved by this).
  function likePhoto(e) {
    const save = landing.querySelector('.wm-save-button[data-shopify-favorite]');
    if (save && !save.classList.contains('is-saved')) save.click();
    else if (save) toast(t('محفوظة في مفضلاتكِ 🤍', 'Already in your favourites 🤍'));
    if (calm || !stage) return;
    const r = stage.getBoundingClientRect();
    const big = el('span', 'w99-bigheart', '<svg viewBox="0 0 24 24"><path d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.8 4.5c2.1 0 3.6 1.2 4.4 2.5.8-1.3 2.3-2.5 4.4-2.5 3.8 0 5.9 3.9 4.4 7.3C19.5 16.4 12 21 12 21z"/></svg>', true);
    big.style.left = ((e?.clientX ?? r.left + r.width / 2) - r.left) + 'px';
    big.style.top = ((e?.clientY ?? r.top + r.height / 2) - r.top) + 'px';
    stage.append(big); setTimeout(() => big.remove(), 1000);
  }

  // Swipe the photo on phones to move through the gallery.
  if (stage && mainImg) {
    let sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', e => { if (e.touches.length !== 1) { tracking = false; return; } tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', e => {
      if (!tracking) return; tracking = false;
      const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      const forward = ar ? dx > 0 : dx < 0;
      const btn = stage.querySelector(forward ? '.wm-next' : '.wm-prev');
      if (!btn) return;
      mainImg.dataset.w99Swiped = '1'; setTimeout(() => { delete mainImg.dataset.w99Swiped; }, 400);
      stage.style.setProperty('--w99-swipe', (forward === !ar ? -1 : 1) * 26 + 'px');
      btn.click();
      if (navigator.vibrate) { try { navigator.vibrate(6); } catch (err) {} }
    }, { passive: true });
  }

  // Photo changes (thumbnail, arrow, swipe or a new colour) melt in from a soft blur, and a glow in the photo's own
  // colour breathes behind the gallery.
  const gallery = landing.querySelector('.wm-gallery');
  const ambient = () => {
    if (!gallery || !mainImg) return;
    const src = (mainImg.currentSrc || mainImg.src || '').replace(/([?&])width=\d+/, '$1width=40');
    if (!src) return;
    const probe = new Image(); probe.crossOrigin = 'anonymous';
    probe.onload = () => {
      try {
        const c = document.createElement('canvas'); c.width = c.height = 12;
        const g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(probe, 0, 0, 12, 12);
        const d = g.getImageData(0, 0, 12, 12).data; let R = 0, G = 0, B = 0, n = 0;
        for (let i = 0; i < d.length; i += 4) { const mx = Math.max(d[i], d[i + 1], d[i + 2]), mn = Math.min(d[i], d[i + 1], d[i + 2]); if (mx > 245 && mn > 235) continue; const w = 1 + (mx - mn) / 40; R += d[i] * w; G += d[i + 1] * w; B += d[i + 2] * w; n += w; }
        if (n) gallery.style.setProperty('--w99-ambient', `rgb(${Math.round(R / n)} ${Math.round(G / n)} ${Math.round(B / n)} / .55)`);
        gallery.classList.add('w99-ambient');
      } catch (err) { /* image not readable here: no glow */ }
    };
    probe.src = src;
  };
  if (mainImg) {
    if (mainImg.complete) ambient(); else mainImg.addEventListener('load', ambient, { once: true });
    let lastSrc = mainImg.getAttribute('src');
    new MutationObserver(() => {
      const now = mainImg.getAttribute('src'); if (now === lastSrc) return; lastSrc = now;
      if (!calm) { mainImg.classList.remove('w99-morph'); void mainImg.offsetWidth; mainImg.classList.add('w99-morph'); }
      mainImg.addEventListener('load', ambient, { once: true });
    }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    mainImg.addEventListener('animationend', () => { mainImg.classList.remove('w99-morph'); stage?.style.removeProperty('--w99-swipe'); });
  }

  // A new price flips in like a split-flap display when the size or colour changes.
  if (priceEl && !calm) {
    let lastPrice = priceEl.textContent;
    new MutationObserver(() => {
      if (priceEl.textContent === lastPrice) return; lastPrice = priceEl.textContent;
      priceEl.classList.remove('w99-flip'); void priceEl.offsetWidth; priceEl.classList.add('w99-flip');
    }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    priceEl.addEventListener('animationend', () => priceEl.classList.remove('w99-flip'));
  }

  // Tiny tap feel when choosing a colour or size (Android).
  landing.addEventListener('click', e => { if (e.target.closest('[data-wm-value], [data-wm-print], .wm-thumb') && navigator.vibrate) { try { navigator.vibrate(5); } catch (err) {} } });

  // Add to bag: the product photo flies into the bag icon, which then bounces.
  const flyTo = (target, from, src, cls) => {
    if (calm || !target || !from) return;
    const a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!b.width || !a.width) return;
    const ghost = el('img', 'w99-fly ' + (cls || ''), null, true);
    if (src) ghost.src = src;
    const size = Math.min(84, a.width);
    ghost.style.cssText = `left:${a.left + a.width / 2 - size / 2}px;top:${a.top + a.height / 2 - size / 2}px;width:${size}px;height:${size}px`;
    document.body.append(ghost);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = ghost.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
      { transform: `translate(${dx * 0.45}px,${dy * 0.45 - 90}px) scale(.7) rotate(${ar ? 10 : -10}deg)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px,${dy}px) scale(.18) rotate(0)`, opacity: 0.2 }
    ], { duration: 820, easing: 'cubic-bezier(.45,.05,.3,1)' });
    anim.onfinish = () => { ghost.remove(); target.classList.remove('w99-bump'); void target.offsetWidth; target.classList.add('w99-bump'); };
  };
  const visible = sel => [...document.querySelectorAll(sel)].find(n => { const r = n.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < innerHeight; });
  document.addEventListener('click', e => {
    const b = e.target.closest('.wm-add, .w99-buybar button');
    if (!b || b.disabled || !mainImg) return;
    flyTo(visible('.site-header .bag-button, .bag-button'), visible('.wm-main-image') || b, thumb());
  });
  // Saving a favourite sends a little heart to the heart in the header.
  document.addEventListener('wamory:favorite', e => {
    const f = e.detail?.button;
    if (!e.detail?.adding || !f || !landing.contains(f)) return;
    flyTo(visible('.site-header .favorites-action, .favorites-action'), f.querySelector('svg') || f, 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#e47c93" d="M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.8 4.5c2.1 0 3.6 1.2 4.4 2.5.8-1.3 2.3-2.5 4.4-2.5 3.8 0 5.9 3.9 4.4 7.3C19.5 16.4 12 21 12 21z"/></svg>'), 'w99-fly-heart');
  });

  // Tilt the phone and the photo leans with it, like a hologram card (Android; iPhone asks for motion access, so it is skipped there).
  if (stage && mainImg && !calm && !fine && 'DeviceOrientationEvent' in window && typeof DeviceOrientationEvent.requestPermission !== 'function') {
    let base = null, frame = 0, rx = 0, ry = 0, onScreen = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { onScreen = en.isIntersecting; if (!onScreen) { stage.style.removeProperty('--w99-tx'); stage.style.removeProperty('--w99-ty'); } }).observe(stage);
    window.addEventListener('deviceorientation', e => {
      if (!onScreen || e.beta == null || e.gamma == null) return;
      if (!base) base = { b: e.beta, g: e.gamma };
      ry = Math.max(-6, Math.min(6, (e.gamma - base.g) * 0.35)); rx = Math.max(-6, Math.min(6, -(e.beta - base.b) * 0.3));
      if (!frame) frame = requestAnimationFrame(() => { stage.classList.add('w99-holo'); stage.style.setProperty('--w99-tx', rx.toFixed(2) + 'deg'); stage.style.setProperty('--w99-ty', ry.toFixed(2) + 'deg'); frame = 0; });
    }, { passive: true });
  }

  // A soft light sweeps across the add button now and then, and a press sends a ripple from the finger.
  if (addBtn && !calm) {
    addBtn.classList.add('w99-shine');
    const clip = el('span', 'w99-ripple-box', null, true);
    addBtn.append(clip);
    addBtn.addEventListener('pointerdown', e => {
      if (addBtn.disabled) return;
      const r = addBtn.getBoundingClientRect(), ring = el('span', 'w99-ripple', null, true);
      ring.style.left = (e.clientX - r.left) + 'px'; ring.style.top = (e.clientY - r.top) + 'px';
      clip.append(ring); setTimeout(() => ring.remove(), 650);
    });
  }

  // Recently viewed: remember this product, show the others.
  const key = 'wm-recently-viewed';
  const list = (store.get(key) || []).filter(p => p && p.u !== location.pathname);
  const here = { u: location.pathname, t: title, i: thumb(), p: priceEl?.textContent.trim() || '' };
  store.set(key, [here, ...list].slice(0, 12));
  const show = list.slice(0, 10);
  if (show.length >= 2) {
    const sec = el('section', 'w99-recent');
    sec.setAttribute('aria-labelledby', 'w99-recent-title');
    sec.innerHTML = `<h2 id="w99-recent-title">${t('شاهدتِ مؤخرًا', 'Recently viewed')} ✨</h2><div class="w99-recent-row">${show.map(p => `<a href="${esc(p.u)}"><img src="${esc(p.i)}" alt="" loading="lazy" width="150" height="150"><strong>${esc(p.t)}</strong><span>${esc(p.p)}</span></a>`).join('')}</div>`;
    (landing.querySelector('.wm-related') || landing.querySelector('.wm-bottom-trust'))?.before(sec);
  }
})();
